export class GetMissingReportsForMonthRequest {
  public cmd: string = "get_missing_reports_for_month";
  constructor(public month: number, public year: number) { }
}
